import { EntityToGroup, EntityType, groupNavItems } from '@payloadcms/ui/shared'
import { ServerProps } from 'payload'
import { FC } from 'react'
import { getNavPrefs } from './getNavPrefs'
import { NavWrapper } from './NavWrapper'
import { RenderServerComponent } from '@payloadcms/ui/elements/RenderServerComponent'
import { Logout } from '@payloadcms/ui'
import { NavClient } from './index.client'
import { NavHamburger } from './NavHamburger'

export const baseClass = 'nav'

export const Nav: FC<ServerProps> = async (props) => {
  const {
    documentSubViewType,
    i18n,
    locale,
    params,
    payload,
    permissions,
    searchParams,
    user,
    viewType,
    visibleEntities,
  } = props

  if (!payload?.config || !permissions) {
    return null
  }

  const {
    admin: {
      components: { afterNavLinks, beforeNavLinks, logout },
    },
    collections,
    globals,
  } = payload.config

  const groups = groupNavItems(
    [
      ...collections
        .filter(({ slug }) => visibleEntities?.collections.includes(slug))
        .map(
          (collection) =>
            ({
              type: EntityType.collection,
              entity: collection,
            }) satisfies EntityToGroup,
        ),
      ...globals
        .filter(({ slug }) => visibleEntities?.globals.includes(slug))
        .map(
          (global) =>
            ({
              type: EntityType.global,
              entity: global,
            }) satisfies EntityToGroup,
        ),
    ],
    permissions,
    i18n,
  )

  const navPreferences = await getNavPrefs({ payload, user })

  const LogoutComponent = RenderServerComponent({
    clientProps: {
      documentSubViewType,
      viewType,
    },
    Component: logout?.Button,
    Fallback: Logout,
    importMap: payload.importMap,
    serverProps: {
      i18n,
      locale,
      params,
      payload,
      permissions,
      searchParams,
      user,
    },
  })

  const isRTL = i18n?.language === 'ar'

  return (
    <NavWrapper baseClass={baseClass}>
      <nav className={`${baseClass}__wrap relative`} 
        style={{ 
          fontFamily: isRTL ? 'Cairo, Manrope, sans-serif' : 'Manrope, sans-serif',
        }}>
        {RenderServerComponent({
          clientProps: {
            documentSubViewType,
            viewType,
          },
          Component: beforeNavLinks,
          importMap: payload.importMap,
          serverProps: {
            i18n,
            locale,
            params,
            payload,
            permissions,
            searchParams,
            user,
          },
        })}
        <NavClient groups={groups} navPreferences={navPreferences} />
        {RenderServerComponent({
          clientProps: {
            documentSubViewType,
            viewType,
          },
          Component: afterNavLinks,
          importMap: payload.importMap,
          serverProps: {
            i18n,
            locale,
            params,
            payload,
            permissions,
            searchParams,
            user,
          },
        })}
        {/* <div className={`${baseClass}__link w-full`}>
          <div className={`${baseClass}__link-icon`}>{LogoutComponent}</div>
          <span className={`${baseClass}__link-label`}>Logout</span>
        </div> */}
        {/* <div className={`${baseClass}__controls`}>{LogoutComponent}</div> */}
      </nav>
      <div className={`${baseClass}__header`}>
        <div className={`${baseClass}__header-content`}>
          <NavHamburger baseClass={baseClass} />
        </div>
      </div>
    </NavWrapper>
  )
}
